



































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Competency } from '@/models/competency/competency';
import { PagingData } from '@/models/core/paging-data';
import { Component, Watch } from 'vue-property-decorator';
import { Student } from '@/models/student/student';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { Tag } from '@/models/tag';
import { studentFilterModule } from '@/store/modules/frames/student-filters.module';
import { masterModule } from '@/store/modules/entities/master.module';
import { studentModule } from '@/store/modules/entities/student.module';
import { StudentSearch } from '@/models/student/student-search';
import GStudentFilter from '@/components/GStudentFilter.vue';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import { homeModule } from '@/store/modules/frames/home.module';
import * as FileSaver from 'file-saver';
import { GEnum } from '@/constants/enum.defination';

Component.registerHooks(['beforeRouteEnter']);
@Component({
  name: 'GHome',
  components: {
    GCompetencyLabel,
    GTitleBar,
    GCustomBreadCrumb,
    GStudentFilter,
  },
})
export default class GHome extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  studentListColumn: object[] = [];
  studentDataPerPage: number = 15;
  studentDataOffset: number = 0;
  isStudentFilterAwait: boolean = false;
  isStudentSearchLoading: boolean = false;
  isSearchResultShow = false;
  lazy: boolean = false; // 遅延描画(進級画面へのリダイレクトをホーム画面を最初に表示することなく実施させるため)
  isFindingsProposalsListLoading = false;
  sortKey: GEnum.StudentSortKey = GEnum.StudentSortKey.Grade;
  sortType: GEnum.SortType = GEnum.SortType.Asc;

  @Watch('students')
  loadStudents() {
    this.isStudentSearchLoading = false;
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name !== 'student-record') {
        //生徒カルテ画面から戻ってきた時のみ、キャッシュデータを保持する
        vm.clearStudentFilters();
        vm.clearStudents();
        vm.initCurrentPage();
      }

      if (!vm.isCompletedInitialSetting) {
        next({ path: '/pages/academicPromotion' });
      }
      vm.isStudentFilterAwait = true;
    });
  }

  async mounted() {
    this.breadCrumbItems = [{ title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' }];
    await masterModule.fetchCompetency();
    this.createColumn();
    this.lazy = true;

    // 初回検索実行
    this.$nextTick(() => {
      //  refsを用いて、生徒検索フィルターのインスタンスが生成されたあとに検索実行する
      const { gStudentFilter }: any = this.$refs;
      gStudentFilter.handleFormSubmit();
    });
  }

  isResponsibleSchoolClass(schoolClassID: number): boolean {
    return this.$store.state.account.isResponsibleSchoolClass(schoolClassID);
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get isCompletedInitialSetting(): boolean {
    return this.$store.state.account.isCompletedInitialSetting;
  }

  get tags(): Tag[] {
    return studentFilterModule.tags;
  }

  get grade(): number {
    return studentFilterModule.grade;
  }

  get schoolClassID(): number {
    return studentFilterModule.schoolClassID;
  }

  get searchWord(): string {
    return studentFilterModule.searchWord;
  }

  get competencies(): Array<Competency> {
    return masterModule.competencies as Array<Competency>;
  }

  get students(): PagingData<Student> {
    return studentModule.students;
  }

  get targetType(): number {
    return studentFilterModule.targetType;
  }

  get targetID(): number {
    return studentFilterModule.targetID;
  }

  clearStudents() {
    studentModule.clearStudents();
  }

  clearStudentFilters(): void {
    studentFilterModule.clear();
  }

  createColumn(): void {
    this.studentListColumn = [
      this.columnStudentID,
      this.columnName,
      this.columnGrade,
      this.columnSchoolClassName,
      this.columnManageNumber,
      this.highCompetencyID,
      this.lowCompetencyID,
      this.potentialCompetencyID,
      this.learningIncentive,
    ];
  }

  get columnStudentID(): any {
    return {
      title: this.$t('LOGIN_ID').toString(),
      key: 'studentNumber',
      sortable: 'custom',
      width: 100,
      align: 'center',
    };
  }

  get columnName(): any {
    return {
      title: this.$t('FULL_NAME').toString(),
      slot: 'full-name',
      width: 180,
      align: 'center',
    };
  }

  get columnGrade(): any {
    return {
      title: this.$t('GRADE').toString(),
      key: 'schoolClass',
      sortable: 'custom',
      width: 70,
      align: 'center',
      render: (h: any, params: any) => {
        const selectedRow: Student = this.students.data[params.index];
        const schoolYear = selectedRow.schoolClass.grade;
        return h('span', {}, schoolYear);
      },
    };
  }

  get columnSchoolClassName(): any {
    return {
      title: this.$t('SCHOOL_CLASS').toString(),
      key: 'schoolClassName',
      sortable: 'custom',
      align: 'center',
      render: (h: any, params: any) => {
        const student: Student = this.students.data[params.index];
        const schoolClassName = student.schoolClass.schoolClassName;

        return h(
          'Tooltip',
          {
            props: {
              content: schoolClassName,
              placement: 'right',
              ['max-width']: 200,
              disabled: !this.isOverLength(schoolClassName, 16),
            },
          },
          [h('span', {}, this.simpleText(schoolClassName, 16))]
        );
      },
    };
  }

  get columnManageNumber() {
    return {
      title: this.$t('MANAGE_NUMBER').toString(),
      key: 'manageNumber',
      sortable: 'custom',
      width: 100,
      align: 'center',
    };
  }

  get highCompetencyID(): any {
    return {
      title: this.$t('HIGH_COMPETENCY').toString(),
      width: 180,
      slot: 'high-competency',
      align: 'center',
    };
  }

  get lowCompetencyID(): any {
    return {
      title: this.$t('LOW_COMPETENCY').toString(),
      width: 180,
      slot: 'low-competency',
      align: 'center',
    };
  }

  get potentialCompetencyID(): any {
    return {
      title: this.$t('COMPETENCY_EASILY_DEVELOP').toString(),
      width: 180,
      slot: 'potential-competency',
      align: 'center',
    };
  }

  get learningIncentive(): any {
    return {
      title: this.$t('TREND_STYLE').toString(),
      key: 'learningIncentive',
      width: 110,
      align: 'center',
      render: (h: any, params: any) => {
        const selectedRow: Student = this.students.data[params.index];
        if (selectedRow.learningIncentive != null || selectedRow.learningIncentive != undefined) {
          if (selectedRow.learningIncentive.length > 0) {
            let learningIncentiveArr: any[] = selectedRow.learningIncentive.map((learningIncentive) => {
              return h('p', {}, learningIncentive);
            });
            return h('div', {}, learningIncentiveArr);
          }
        }
        return h('span', {}, '');
      },
    };
  }

  get currentPage(): number {
    return homeModule.currentPage;
  }

  get competencyMap(): Map<number, Competency> {
    return masterModule.competencyMap;
  }

  initCurrentPage() {
    homeModule.setCurrentPage(1);
  }

  handleSort(event: any): void {
    if (!event) {
      return;
    }
    this.sortType = event.order == 'desc' ? GEnum.SortType.Desc : GEnum.SortType.Asc;
    // key:fullName(sortKey=2)は廃止
    switch (event.key) {
      case 'studentNumber':
        this.sortKey = GEnum.StudentSortKey.StundentNumber;
        break;
      case 'schoolClass':
        this.sortKey = GEnum.StudentSortKey.Grade;
        break;
      case 'schoolClassName':
        this.sortKey = GEnum.StudentSortKey.Class;
        break;
      case 'manageNumber':
        this.sortKey = GEnum.StudentSortKey.ManageNumber;
        break;
    }
    this.handleSearchStudents();
  }

  handleSearchSubmit(): void {
    this.studentDataPerPage = 15;
    this.studentDataOffset = 0;
    this.isSearchResultShow = true;
    this.initCurrentPage();
    this.handleSearchStudents();
  }

  handlePagerChange(pageNumber: number): void {
    this.studentDataOffset = (pageNumber - 1) * this.studentDataPerPage;
    homeModule.setCurrentPage(pageNumber);
    this.handleSearchStudents();
  }

  handleSearchStudents(): void {
    this.isStudentSearchLoading = true;
    let studentSearchOptions: StudentSearch = {
      targetType: this.targetType,
      targetID: this.targetID,
      keyword: this.searchWord,
      selectedTagIDs: studentFilterModule.commaSelectedTagIDs,
      offset: this.studentDataOffset,
      limit: this.studentDataPerPage,
      sortKey: this.sortKey,
      sortType: this.sortType,
      hasScore: true,
    };
    studentModule.fetchStudents(studentSearchOptions);
  }

  handleFindingsProposalsListDownload() {
    this.isFindingsProposalsListLoading = true;
    // 学籍番号は検索フィルターで設定できないので、studentSearchOptionsにも設定しない
    let studentSearchOptions: StudentSearch = {
      targetType: this.targetType,
      targetID: this.targetID,
      keyword: this.searchWord,
      selectedTagIDs: studentFilterModule.commaSelectedTagIDs,
    };
    studentModule.downloadFindingsProposalsList(studentSearchOptions).then((response: any) => {
      this.isFindingsProposalsListLoading = false;
      FileSaver.saveAs(response, this.$t('FILE_NAME.FINDINGS_PROPOSALS_LIST').toString());
    });
  }

  /**
   * 内田洋行タイプ
   */
  get isDispCtrlTypeUchida(): boolean {
    return this.$store.state.account.dispCtrlType === GEnum.DispCtrlType.Uchida;
  }
}
